<template>
    <router-view/>
</template>

<script>
export default {
    name: "base"
}
</script>

<style scoped>

</style>
